import { render, staticRenderFns } from "./AssignmentDashboard.vue?vue&type=template&id=52d0c8dc&scoped=true"
import script from "./AssignmentDashboard.vue?vue&type=script&lang=js"
export * from "./AssignmentDashboard.vue?vue&type=script&lang=js"
import style0 from "./AssignmentDashboard.vue?vue&type=style&index=0&id=52d0c8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d0c8dc",
  null
  
)

export default component.exports